import { Command } from "../../models/Command";

export class AddBlankSection extends Command {
  _section = null;
  _isGlobal = true;
  constructor({ actionForward, actionBackward, index, callBack }) {
    super({ actionForward, actionBackward, index, callBack });
  }

  async execute() {
    const { actionForward, index, callBack } = this.args;
    const section = await actionForward(index, callBack);
    this._section = section;
  }

  async undo() {
    console.log("AddBlankSection undo command");
    if (!this._section) {
      throw new Error("No section provided");
    }
    const { actionBackward, index, callBack } = this.args;
    await actionBackward(this._section, index, callBack);
  }

  get isGlobal() {
    return this._isGlobal;
  }

  getInfo() {
    return "This is AddBlankSection command";
  }
}
